import { useContext } from 'react';
import FieldViewerContext from '../../../../contexts/components/field-viewer/FieldViewerContext';

export default function useFieldViewerState() {
  const values = useContext(FieldViewerContext);

  return values;
}
